import { call } from 'redux-saga/effects';
import { BiEvent } from 'analytics';
import { select } from 'redux-saga/effects';
import { User } from 'utils/entities';
import { waitForUserChange } from '../routing/handlers/utils';
import { isAgentManagerSelector, userProfileSelector, approvedAgentSelector } from 'store/state/domainData/selectors';

export function* userPreProcessor({ name, category, payload }: BiEvent) {
  yield call(waitForUserChange, (_, b) => !b);
  const user: User = yield select(userProfileSelector);
  if (user && user.uid) {
    const isAgentManager = yield select(isAgentManagerSelector);
    const isApprovedAgent = yield select(approvedAgentSelector);
    const officeManagerRole = isAgentManager ? (isApprovedAgent ? 'agent_manager' : 'agent_manager_not_agent') : null;

    const userRoles = [ ...user.roles, officeManagerRole ].filter(Boolean).map(role => role.toLowerCase());
    return {
      name,
      category,
      payload: {
        ...payload,
        common: {
          user_id: user.uid,
          user_roles: userRoles,
        },
      },
    };
  }

  return { name, category, payload };
}
